import Logo from "public/assets/fnn-icon.svg"

export default function Divider({}) {
  return (
    <div className="h-10 my-2 flex items-center justify-between">
      <div className="border-t-[1px] border-white h-1 w-[50%]"></div>
      <Logo className="mx-4" />
      <div className="border-t-[1px] border-white h-1 w-[50%]"></div>
    </div>
  )
}
